import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoDependencia, TipoDependenciaProps } from '../../interfaces/catalogos/TipoDependenciaInterface';

export const TipoDependencias = () => {

    return new Promise<TipoDependenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDependencia/', token)
            .then( ({ data } : { data : TipoDependenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoDependencia = () => {

    return new Promise<TipoDependenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDependencia/ObtenerTipoDependencias', token)
            .then( ({ data } : { data : TipoDependenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoDependencia = ( params: TipoDependenciaProps ) => {

    return new Promise<TipoDependenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDependencia/Actualizar', params, token)
            .then( ({ data } : { data : TipoDependenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDependencia });
            });

        }

    });

}

export const AgregarTipoDependencia = ( params: TipoDependenciaProps ) => {

    return new Promise<TipoDependenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDependencia/Agregar', params, token)
            .then( ({ data } : { data : TipoDependenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDependencia });
            });

        }

    });

}
